import _createForOfIteratorHelper from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["src"];
import { watchEffect, ref } from "../../../../adapter-vue";
import Icon from "../../../common/Icon.vue";
import audioIcon from "../../../../assets/icon/msg-audio.svg";
import { isPC } from "../../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'message-audio',
  props: {
    content: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    messageItem: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var data = ref();
    var message = ref();
    var show = ref();
    var audioRef = ref(null);
    watchEffect(function () {
      message.value = props.messageItem;
      data.value = props.content;
    });
    var play = function play() {
      if (message.value.hasRiskContent) {
        return;
      }
      var audios = document.getElementsByTagName("audio");
      var _iterator = _createForOfIteratorHelper(audios),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var audio = _step.value;
          if (!audio.paused) {
            audio.pause();
            audio.load();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var audioPlayer = audioRef.value;
      if (audioPlayer.paused) {
        audioPlayer.play();
        show.value = true;
      } else {
        audioPlayer.pause();
        audioPlayer.load();
        show.value = false;
      }
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["message-audio", [!_unref(isPC) && 'message-audio-h5', _unref(message).flow === 'out' && 'reserve', _unref(message).hasRiskContent && 'disable']]),
        onClick: _withModifiers(play, ["stop"])
      }, [_createVNode(Icon, {
        "class": "icon",
        file: _unref(audioIcon)
      }, null, 8, ["file"]), _createElementVNode("label", {
        "class": "time",
        style: _normalizeStyle({
          width: "".concat(_unref(data).second * 10 + 20, "px")
        })
      }, _toDisplayString(_unref(data).second || 1) + " \" ", 5), _createElementVNode("audio", {
        ref_key: "audioRef",
        ref: audioRef,
        src: _unref(data).url
      }, null, 8, _hoisted_1)], 2);
    };
  }
});